import {
  NodeResultSummaryPresignedUrlRequest,
  RouterPresignedUrls,
  VersionNodeResultsPagePresignedUrlRequest,
} from "src/api/endpoints";

const fetchS3Url = async <T>(s3Url: string): Promise<T> => {
  try {
    const fetchResult = await fetch(s3Url);
    if (fetchResult.status !== 200) {
      throw new Error(
        `Error fetching results, status: ${
          fetchResult.status
        } ${await fetchResult.text()}`,
      );
    }
    const resultObject: Promise<T> = await fetchResult.json();
    return await resultObject;
  } catch (e) {
    throw new Error(`Error fetching results: ${e}`);
  }
};

export const fetchTestRunResultDataUrl = async <TRow>(
  workspaceBaseUrl: string,
  pageParam: VersionNodeResultsPagePresignedUrlRequest,
) => {
  const resultsUrlResponse = await RouterPresignedUrls.post(
    workspaceBaseUrl,
    pageParam.run_id,
    pageParam,
  );
  return await fetchS3Url<Record<string, TRow[]>>(resultsUrlResponse.data.url);
};

export type TrimmingReport = {
  readonly non_trimmed?: number;
  readonly partially_trimmed?: number;
  readonly fully_trimmed?: number;
};

interface OptionalTrimmingReportContainer {
  readonly trimming_report?: TrimmingReport;
}

export interface FetchTestRunTrimmingReportParams {
  readonly workspaceBaseUrl: string;
  readonly run_id: string;
  readonly version_id: string;
  readonly node_id: string;
}

export const fetchTestRunTrimmingReport = async ({
  workspaceBaseUrl,
  run_id,
  version_id,
  node_id,
}: FetchTestRunTrimmingReportParams): Promise<TrimmingReport | undefined> => {
  const request: NodeResultSummaryPresignedUrlRequest = {
    type: "node_result_summary",
    run_id: run_id,
    version_id: version_id,
    node_id: node_id,
  };
  const presignedUrlResponse = await RouterPresignedUrls.post(
    workspaceBaseUrl,
    request.run_id,
    request,
  );
  const result = await fetchS3Url<OptionalTrimmingReportContainer>(
    presignedUrlResponse.data.url,
  );
  return result.trimming_report;
};
